import React from 'react';
import PropTypes from 'prop-types';
import colors from 'theme/_colors.scss';

const IconRecommendation = ({ width = 16, height = 16, color = colors.doveGray }) =>
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 16 16' fill='none'>
        <path d='M14.4549 3.737L11.1649 7.03L8.97489 4.838L12.2649 1.546L11.7199 1H8.98389L6.23989 3.737V7.576L3.83489 9.982L3.37689 10.44L1.49789 12.32C1.27467 12.5297 1.11725 12.7998 1.04481 13.0974C0.972364 13.3949 0.988028 13.7072 1.08989 13.996C1.18347 14.2382 1.33575 14.4535 1.53306 14.6223C1.73037 14.7912 1.96653 14.9084 2.22033 14.9634C2.47412 15.0184 2.73761 15.0095 2.98713 14.9375C3.23665 14.8656 3.46439 14.7327 3.64989 14.551L4.83689 13.362L5.26589 12.905L8.42889 9.768H12.2649L14.9999 7.03V4.293L14.4549 3.737Z' fill={color} />
    </svg>
    ;

IconRecommendation.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string
};
export default IconRecommendation;
